<template>
  <div class="page-content zizhiAuthJigou_xgzz" :style="defaultHeight" id="page-content">
    <div class="startTitle">机构入驻</div>
    <el-row>
      <el-col :span="16" :offset="4">
        <ul class="stepBox">
          <li class="stepText">
            <img src="../../assets/images/back/step.png" alt="">
            <span class="act">基本信息</span>
          </li>
          <li class="stepLine act"></li>
          <li class="stepText">
            <img src="../../assets/images/back/step.png" alt="">
            <span class="act">相关资质</span>
          </li>
          <li class="stepLine"></li>
          <li class="stepText">
            <img src="../../assets/images/back/stepno.png" alt="">
            <span>提交审核</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row style="margin-top: 50px">
      <el-col :span="15" :offset="4">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="营业执照" prop="yezzphoto" class="setLine">
            <div class="borBox " :style="ruleForm.yezzphoto.length == 0?'text-align:center;height: 190px;':''">
              <div :class="index==1?'item-img mr0':'item-img'" v-for="(item,index) in ruleForm.yezzphoto" :key="item">
                <img :src="item" alt="" :class="index==0?'padl5':'padr5'">
                <div class="delbtn" @click="delyyimg(index)">x</div>
              </div>
              <el-upload v-if="ruleForm.yezzphoto.length<2" class="upload-demo w100" :action="imgAction" :http-request="yyimgs_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="yyimgs_handleSuccess" :before-upload="beforeUpload">
                <div class="w100box">
                  <el-button icon="el-icon-plus" circle></el-button>
                  <div>上传图片</div>
                </div>
              </el-upload>
            </div>

            <input type="hidden" v-model="ruleForm.yezzphoto">
            <div class="el-upload__tip" style="line-height: 20px">企业名称必须要与企业工商营业执照的企业名称一直，若办理过三证合一的企业，请上传最新的营业执照。</div>
            <div class="el-upload__tip" style="line-height: 20px"> 格式要求：原件照片、扫描件或加盖公章的复印件，请使用jpg格式照片，大小不超过5M</div>
          </el-form-item>

          <el-form-item label="证件照片" required>
            <div class="border">
              <el-col :span="11">
                <el-form-item prop="photo.credenPhotofront">
                  <div class="credenPhoto">
                    <el-upload class="btn-plus" :action="imgAction" :http-request="front_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="front_handleSuccess" :before-upload="beforeUpload">
                      <img v-if="ruleForm.photo.credenPhotofront" :src="ruleForm.photo.credenPhotofront">
                      <div v-else class="item-img">
                        <img src="../../assets/images/back/credenPhotofront.png" alt="">
                      </div>
                      <el-button icon="el-icon-plus" circle></el-button>
                    </el-upload>
                    <span class="tipText">上传身份证人像面</span>
                  </div>
                  <input type="hidden" v-model="ruleForm.photo.credenPhotofront">
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2" style="color: #ffffff">-</el-col>
              <el-col :span="11">
                <el-form-item prop="photo.credenPhotoback">
                  <div class="credenPhoto">

                    <el-upload class="btn-plus" :action="imgAction" :http-request="back_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="back_handleSuccess" :before-upload="beforeUpload">
                      <img v-if="ruleForm.photo.credenPhotoback" :src="ruleForm.photo.credenPhotoback">
                      <div v-else class="item-img">
                        <img src="../../assets/images/back/credenPhotoback.png" alt="">
                      </div>
                      <el-button icon="el-icon-plus" circle></el-button>
                    </el-upload>
                    <span class="tipText">上传身份证国徽面</span>
                    <input type="hidden" v-model="ruleForm.photo.credenPhotoback">
                  </div>
                </el-form-item>
              </el-col>
            </div>

            <div class="el-upload__tip">请使用jpg格式照片，大小不超过5M</div>

          </el-form-item>

          <el-form-item label="税务登记证" prop="swphoto" class="setLine">
            <div class="borBox" :style="ruleForm.swphoto.length==0?'text-align:center;height: 190px;':''">
              <div :class="index==1?'item-img mr0':'item-img'" v-for="(item,index) in ruleForm.swphoto" :key="item">
                <img :src="item" alt="" :class="index==0?'padl5':'padr5'">
                <div class="delbtn" @click="delswimg(index)">x</div>
              </div>
              <el-upload v-if="ruleForm.swphoto.length<2" class="upload-demo w100" :action="imgAction" :http-request="swimgs_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="swimgs_handleSuccess" :before-upload="beforeUpload">
                <div class="w100box">
                  <el-button icon="el-icon-plus" circle></el-button>
                  <div>上传图片</div>
                </div>
              </el-upload>
            </div>

            <input type="hidden" v-model="ruleForm.swphoto">
            <div class="el-upload__tip" style="line-height: 30px;">请使用jpg格式照片，大小不超过5M。</div>
          </el-form-item>

          <el-form-item>
            <el-button type="success" class="btn-save" @click="submitForm('ruleForm')">保存</el-button>
            <el-button style="float: right" class="btn-save" @click="toprevPage()">上一步</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import { Notification } from 'element-ui'
import { mechanismSaveMechanism, mechanismSettleIn, uploadImg } from '@/api/myInfo'
import baseAPI from "@/api/baseAPI";

export default {
  name: "zizhiAuthJigou_xgzz",
  data () {
    return {
      //审核失败  修改
      //图片列表（用于在上传组件中回显图片）
      fileList: [],
      // 图片上传地址
      imgAction: null,
      isModifyData: "",
      defaultHeight: {
        height: ""
      },
      ruleForm: {
        yezzphoto: [],
        swphoto: [],
        photo: {
          credenPhotofront: '',
          credenPhotoback: '',
        }
      },
      rules: {
        photo: {
          credenPhotofront: [
            { required: true, message: '请选择上传身份证正面' },
          ],
          credenPhotoback: [
            { required: true, message: '请选择上传身份证反面' },
          ],
        },
        swphoto: [
          { required: true, message: '请选择上传税务登记证' },
        ],
        yezzphoto: [
          { required: true, message: '请选择上传营业执照' },
        ]
      }
    }
  },
  components: {},
  beforeMount () {
    this.userId = this.$store.state.user.userId;
    if (this.userId === "") {
      console.log(Cookies.get("userInfo"));
      this.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
    }

    var query = this.$router.currentRoute.query;
    console.log("333333333333333333333333333333333");
    console.log(query);
    if (query.isModifyData === undefined) {
      this.isModifyData = "false";
    } else {
      this.isModifyData = "true";
    }
    this.mechanismSettleIn();
    this.getImgAction();
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();

  },

  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = document.getElementById("page-content") - 105 + "px";
    },
    // 赋值文件上传路径
    getImgAction () {
      let _this = this;
      // _this.imgAction = process.env.VUE_APP_BASE_API + '/device/product/uploadImg';
      _this.imgAction = baseAPI + '/device/product/uploadImg';
    },
    delyyimg (index) {
      this.ruleForm.yezzphoto.splice(index, 1);
    },
    delswimg (index) {
      this.ruleForm.swphoto.splice(index, 1);
    },
    message (text) {
      this.$message({
        message: text,
        type: 'warning'
      });
    },

    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isGIF = file.type === 'image/gif';
      const isPNG = file.type === 'image/png';
      const isBMP = file.type === 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    yyimgs_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '营业执照上传成功',
        duration: 6000
      });
    },
    swimgs_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '税务登记证上传成功',
        duration: 6000
      });
    },
    front_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '身份证人像面图片上传成功',
        duration: 6000
      });
    },
    back_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '身份证国徽面图片上传成功',
        duration: 6000
      });
    },
    front_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.photo.credenPhotofront = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    back_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.photo.credenPhotoback = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    yyimgs_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.yezzphoto.push(response.data.data); //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    swimgs_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.swphoto.push(response.data.data); //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    setData (ths, data) {
      ths.ruleForm.yezzphoto = data.businessLicense.split(",");
      ths.ruleForm.swphoto = data.taxRegistrationCertificate.split(",");
      data.photoOfLegalRepresentative = data.photoOfLegalRepresentative.split(",");
      ths.ruleForm.photo.credenPhotofront = data.photoOfLegalRepresentative[0];
      ths.ruleForm.photo.credenPhotoback = data.photoOfLegalRepresentative[1];
    },
    mechanismSettleIn () {
      var ths = this;
      mechanismSettleIn(this.userId).then((res) => {
        if (parseFloat(res.data.code) === 200) {
          //是否已经提交
          if (res.data.data === "" || res.data.data === undefined || res.data.data === null) {//ok
            // ths.$router.replace('/personCenter/zizhiAuth/zizhiAuthJigou_jbxx');
            return;
          } else if (parseInt(res.data.data.status) === 0) {//审核中 ok
            ths.$router.replace('/personCenter/zizhiAuth/jsgou_submitShenhe');
          } else if (parseInt(res.data.data.status) === 1) {//  审核成功 ok
            //需要上一个接口返回id  强制替换上一个页面
            //ths.$router.replace('/personCenter/zizhiAuth/zizhiAuthJigou_jbxx');
            ths.$router.replace('/personCenter/zizhiAuth/jsgou_submitShenhe');
          } else if (parseInt(res.data.data.status) === 2) {//审核失败  ok
            // ths.message(res.data.msg);
            if (this.isModifyData === "false") {
              ths.$router.replace('/personCenter/zizhiAuth/jsgou_submitShenhe');
            } else {
              if (ths.$router.history.current.query.id === undefined) {
                //需要上一个接口返回id  强制替换上一个页面
                ths.$router.replace('/personCenter/zizhiAuth/zizhiAuthJigou_jbxx');
              } else {
                //需要修改true就回显数据
                ths.setData(ths, res.data.data);
              }
            }
          }
        } else {
          this.message(res.data.msg);
        }
      })
    },
    submitAjax () {
      var ths = this;
      var data = {
        id: ths.$route.query.id,
        businessLicense: this.ruleForm.yezzphoto.join(","),
        taxRegistrationCertificate: this.ruleForm.swphoto.join(","),
        photoOfLegalRepresentative: [this.ruleForm.photo.credenPhotofront, this.ruleForm.photo.credenPhotoback].join(",")
        // credenPhotofront:this.ruleForm.photo.credenPhotofront,
        // credenPhotoback:this.ruleForm.photo.credenPhotoback
      };
      mechanismSaveMechanism(data).then(res => {
        if (parseFloat(res.data.code) === 200) {
          ths.message("提交成功");
          setTimeout(() => {
            ths.$router.push("/personCenter/zizhiAuth/jsgou_submitShenhe");
          }, 1000)

        } else {
          ths.message(res.data.msg);
        }
      });
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toprevPage () {
      this.$router.back(-1)
    }
  },
}
</script>

<style scoped>
.credenPhoto {
  position: relative;
  width: 265px;
  height: 170px;
  /*border: 1px dashed #93A5BD;*/
}

.credenPhoto img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.btn-plus {
  position: relative;
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 170px;
}

.btn-plus .el-button {
  border: 2px solid #000000;
}

.border {
  border: 1px solid #e6dfdf;
  padding: 10px;
  overflow: hidden;
  height: 235px;
}

.w100.upload-demo {
  /*border: 1px solid #e6dfdf;*/
  /*line-height: 150px;*/
  height: 170px;
  text-align: center;
  width: 235px !important;
  display: inline-block;
  position: relative;
  top: 20px;
}

.w100.upload-demo .el-button {
  border: 2px solid #000000;
}

.w100box {
  width: 235px;
  line-height: 40px;
  position: relative;
  top: 40px;
}

.tipText {
  text-align: center;
  display: block;
  line-height: 40px;
  font-size: 14px;
  color: rgba(101, 101, 101, 1);
  font-weight: 600;
  line-height: 2;
  padding-top: 15px;
}

.borBox {
  /*padding: 20px;*/
  border: 1px solid #e6dfdf;
}

.borBox .item-img {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 282px;
  height: 190px;
  margin-bottom: 5px;
  margin-top: 5px;
  margin-right: 20px;
}

.borBox .item-img img {
  width: 100%;
  height: 100%;
}

.borBox .item-img .delbtn {
  display: none;
  position: absolute;
  right: -5px;
  top: -10px;
  width: 20px;
  height: 20px;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  border-radius: 50%;
  background-color: #333333;
  color: #ffffff;
}

.borBox .item-img:hover .delbtn {
  display: block;
  cursor: pointer;
}

.borBox .item-img.mr0 {
  margin-right: 0px;
}

.padl5 {
  padding-left: 5px;
}
.padr5 {
  padding-right: 5px;
}
</style>




// WEBPACK FOOTER //
// src/views/personCenter/zizhiAuthJigou_xgzz.vue